import { Resource ,ResourceLoadContext } from "./resource";
import Stage from "../stage/stage";

export interface SoundAsset
{
    buffer: AudioBuffer;
}


export class SoundResource extends Resource<SoundAsset>
{
   async load(ctx: ResourceLoadContext): Promise<SoundAsset> {
       const response = await ctx.fetchPrivate(this.key);
       if (!response.ok) {
         throw new Error(`Failed to load Sound "${this.key}": ${response.status}`);
       }

       const  context = Stage.instance().sound_service.context;
       if(!context)
       {
         throw new Error(`Failed to get Audio Context "${this.key}"`);
       }

       const array_buffer = await response.arrayBuffer();
       const buffer =   await context.decodeAudioData(array_buffer);
       this._value = {
            buffer
      
        };

        return this._value;
    }

    dispose(_ctx: ResourceLoadContext): void {
    if (this._value) {
      this._value = undefined;
    }
  }
}